import { apiClient } from "lib/apiClient";

export const archiveDeals = async (request: string[]) => {
  const response = await apiClient.post("/deals/archive", request);

  return response.data;
};
